<div class="modal fade {{confirmDialogState? 'show' : ''}}" id="confirm-dialog-static-backdrop"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body bg-white rounded">
        <section class="confirm-dialog" fxLayout="column">
          <h4 mat-dialog-title class="text-bold">{{(args?.title)? args?.title : "Your confirmation is needed"}}</h4>
          <mat-dialog-content class="mb-3">
            <p>{{(args?.message)? args?.message : "Are you sure you want to continue with this action?."}}</p>
          </mat-dialog-content>
          <mat-dialog-actions class="d-flex justify-content-end align-items-center">
            <button mat-raised-button color="primary" class="me-2" (click)="confirm($event)"
              [mat-dialog-close]="true">Confirm</button>
            <button mat-raised-button color="secondary" [mat-dialog-close]="true" (click)="close($event)">Cancel</button>
          </mat-dialog-actions>
        </section>
      </div>
    </div>
  </div>
</div>